export default __webpack_public_path__ + "static/background_smoke_mobile-f8a0fd352036e049b8c16f40e42ba684.png";